

<template>
  <div>
    卡片页
    <div class="triangle-down"></div>
    22
  </div>
</template>

<script>
  export default {
    name: "Card",
    methods:{
      //返回
      back(){
        this.$router.back();
      },
    }
  }
</script>

<style scoped>


  .triangle-down {
    width: 0;
    height: 0;
    border-left: 50px solid transparent;
    border-right: 50px solid transparent;
    border-top: 100px solid red;
  }
</style>



// WEBPACK FOOTER //
// src/test/Card.vue